<section *ngIf="viewModel$ | async as vm" class="is-flex gap-8">

  <ng-container *ngIf="vm.temperatureControlMode === TemperatureControlModes.HEATING">

    <ng-container *ngIf="vm.displayOff && !vm.hasThermostat">
      <app-home-mode-icon
        ga-event="HeatingModeOffToggle"
        icon="on-off"
        [currentMode]="vm.thermMode"
        [mode]="ThermModes.OFF"
        [title]="'legrand-app.__LEG_HEATING_OFF' | AsyncLang | async"
        [titleCancel]="'common-app.__CANCEL_OFF' | AsyncLang | async"
        (click)="toggleThermMode(vm.thermMode, ThermModes.OFF)">
      </app-home-mode-icon>
    </ng-container>

    <app-home-mode-icon
      ga-event="HeatingModeFrostGuardToggle"
      icon="cooling-mode"
      [currentMode]="vm.thermMode"
      [mode]="ThermModes.FROSTGUARD"
      [title]="'legrand-app.__LEG_HEATING_FROST_GUARD' | AsyncLang | async"
      [titleCancel]="'common-app.__CANCEL_FROST_GUARD' | AsyncLang | async"
      (click)="toggleThermMode(vm.thermMode, ThermModes.FROSTGUARD)">
    </app-home-mode-icon>

    <app-home-mode-icon
      ga-event="HeatingModeAwayToggle"
      icon="leaving-home"
      [currentMode]="vm.thermMode"
      [mode]="ThermModes.AWAY"
      [title]="'legrand-app.__LEG_HEATING_AWAY' | AsyncLang | async"
      [titleCancel]="'common-app.__CANCEL_AWAY' | AsyncLang | async"
      (click)="toggleThermMode(vm.thermMode, ThermModes.AWAY)">
    </app-home-mode-icon>
  </ng-container>

  <ng-container *ngIf="vm.temperatureControlMode === TemperatureControlModes.COOLING">
    <app-home-mode-icon
      ga-event="CoolingModeOffToggle"
      icon="on-off"
      [currentMode]="vm.thermMode"
      [mode]="CoolingModes.OFF"
      [title]="'legrand-app.__LEG_HEATING_OFF' | AsyncLang | async"
      [titleCancel]="'common-app.__CANCEL_OFF' | AsyncLang | async"
      (click)="toggleCoolingMode(vm.coolingMode, CoolingModes.OFF)">
    </app-home-mode-icon>

    <app-home-mode-icon
      ga-event="CoolingModeAwayToggle"
      icon="leaving-home"
      [currentMode]="vm.thermMode"
      [mode]="CoolingModes.AWAY"
      [title]="'legrand-app.__LEG_HEATING_AWAY' | AsyncLang | async"
      [titleCancel]="'common-app.__CANCEL_AWAY' | AsyncLang | async"
      (click)="toggleCoolingMode(vm.coolingMode, CoolingModes.AWAY)">
    </app-home-mode-icon>
  </ng-container>

  <ng-container *ngIf="vm.temperatureControlMode === TemperatureControlModes.AUTO">
    <app-home-mode-icon
      ga-event="AutoModeOffToogle"
      icon="on-off"
      [currentMode]="vm.thermMode"
      [mode]="AutoTempModes.OFF"
      [title]="'legrand-app.__LEG_HEATING_OFF' | AsyncLang | async"
      [titleCancel]="'common-app.__CANCEL_OFF' | AsyncLang | async"
      (click)="toggleAutoTempMode(vm.autoTempMode, AutoTempModes.OFF)">
    </app-home-mode-icon>

    <app-home-mode-icon
      ga-event="AutoModeAwayToogle"
      icon="leaving-home"
      [currentMode]="vm.thermMode"
      [mode]="AutoTempModes.AWAY"
      [title]="'legrand-app.__LEG_HEATING_AWAY' | AsyncLang | async"
      [titleCancel]="'common-app.__CANCEL_AWAY' | AsyncLang | async"
      (click)="toggleAutoTempMode(vm.autoTempMode, AutoTempModes.AWAY)">
    </app-home-mode-icon>
  </ng-container>

</section>
